import React from 'react';
import {MenuMobile} from '../../components/modules/pannelli/MenuMobile';
import {ItemCell, ItemContainer } from '../../components/modules/grids/Item';
import {useArticles} from '../../components/hooks/hooks-mongoDB/useArticles';
import {useThemes} from '../../components/hooks/hooks-mongoDB/useThemes';
import imgtw from '../../components/images/tastewines/intestato/Degustazione.png';
import './degustazionevini.scss';
import '../../css/fonts/fonts.scss';

function DegustazioneVini() {
    const {themes} = useThemes();
    // Componente 1 - Carica articles di tastewines
    const { articles: articles_UP } = useArticles('tastewines');
    const articles_Taste = articles_UP || [];
        // Componente 2 - Carica articles di vitigno
    const { articles: articles_Down } = useArticles('vitigno');
    const articles_Vitigno = articles_Down || [];
    // Componente 3 e 4 - Carica Themes di tastewines e vitigno
    const tastewines_Theme = themes[2];
    const vitigno_Theme = themes[9]; 

    const links_Taste = articles_Taste.map(article => ({
        id: article._id,
        titolo: article.articolo_titolo,
        collegamento: article.collegamento
    }));
    
        const links_Vitigno = articles_Vitigno.map(article => ({
            id: article._id,
            titolo: article.articolo_titolo,
            collegamento: article.collegamento
        })); 
    
    return (
        <section className='grid-tema'>
            <div className="tema__photo"
                    style={{
                        backgroundImage: `linear-gradient( to right bottom, rgba(39, 38, 38, 0.2), rgba(29, 26, 26, 0.5)),
                        url(${imgtw})`, 
                        backgroundSize: 'cover',
                        backgroundRepeat: 'no-repeat',
                        backgroundPosition: 'center top',
                        filter: 'brightness(90%)'
                    }} >
                <ItemContainer tema={tastewines_Theme} exTema={vitigno_Theme} links_Up={links_Taste} links_Down={links_Vitigno} /> 
            </div>
            <MenuMobile temi={themes}/>
            <div className="layout__grids">
                <ItemCell item={articles_Taste} />
            </div>
            {vitigno_Theme && <div className="tema__title"><h1 className="title__top">{vitigno_Theme.name}</h1></div> }
            <div className="layout__grids">
                <ItemCell item={articles_Vitigno} />   
            </div>
        </section>
    )
}
export default DegustazioneVini;
